import { CloseIcon } from '../../../assets/icons/Svg';
import { useDispatch } from 'react-redux';
import { clearTypeOfAdditionalModal } from '../../../features/modal/modalSlice';

export default function ClientPackageDetails() {

    const dispatch = useDispatch();

    const handleCloseCategoryAndProduct = () => {
        dispatch(clearTypeOfAdditionalModal())
    }

    return (
        <div className="fixed inset-0 m-0 p-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[102] overflow-hidden">
            <div className="relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto overflow-hidden">
                <div className="flex flex-col w-full h-[90vh] overflow-hidden">
                    <div className="flex flex-col py-5 h-full">
                        {/* Header */}
                        <div className="flex justify-between items-center py-1">
                            <p className="text-sm font-semibold leading-tight text-slate-900">
                                {'Package Details'}
                            </p>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                                onClick={handleCloseCategoryAndProduct}
                            >
                                <CloseIcon />
                            </button>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div>Hello</div>
                        {/* <div className='grid grid-cols-3 gap-2 py-4'>
                            <div className='flex flex-col'>
                                <p className='text-sm'>Name:</p>
                                <p className='text-sm font-medium'>
                                    {packageSummaryBaseOnIdQuery?.packageSummary.packageName}
                                </p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-sm'>Cups</p>
                                <p className='text-sm font-medium'>
                                    {packageSummaryBaseOnIdQuery?.packageSummary.quantity}
                                </p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-sm'>Amount</p>
                                <p className='text-sm font-medium'>
                                    {packageSummaryBaseOnIdQuery?.packageSummary.totalValue.toLocaleString()}
                                </p>
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto">
                            <div className="border rounded relative h-full">
                                <table className="w-full text-sm border-collapse">
                                    <thead className="bg-gray-100 text-gray-700 uppercase text-xs sticky top-0 z-10">
                                        <tr>
                                            <th className="py-3 px-4 text-left border-b">Name</th>
                                            <th className="py-3 px-4 text-left border-b">Category</th>
                                            <th className="py-3 px-4 text-left border-b">Size</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingProductBaseOnCategory ? (
                                            <tr>
                                                <td colSpan={3}>
                                                <Loading message="Loading staff..." />
                                                </td>
                                            </tr>
                                        ) : isErrorProductBaseOnCategory ? (
                                            <tr>
                                                <td colSpan={3}>
                                                    <ErrorMessage message="Unable to load product. Please try again later or refresh the page." />
                                                </td>
                                            </tr>
                                        ) : packageSummaryBaseOnIdQuery?.products?.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={3}
                                                    className="text-center py-4 text-gray-500 border-t"
                                                >
                                                    No products found.
                                                </td>
                                            </tr>
                                        ) : (
                                            packageSummaryBaseOnIdQuery?.products?.map((prod) => (
                                                <tr
                                                    key={prod?.productID}
                                                    className="hover:bg-gray-50 transition-colors"
                                                >
                                                    <td className="py-3 px-4 border-b">
                                                        {prod?.productName}
                                                    </td>
                                                    <td className="py-3 px-4 border-b">
                                                        {prod?.categoryName}
                                                    </td>
                                                    <td className="py-3 px-4 border-b">
                                                        {prod?.size === 'None' ? '' : prod?.size}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
